/**
 * Product Comparison Section - Add to Cart functionality
 * Handles adding products to cart from the comparison table
 */
(function() {
  'use strict';

  /**
   * Initialize add to cart handlers for comparison section
   */
  function init() {
    document.addEventListener('click', handleAddToCartClick);
  }

  /**
   * Handle click events on add to cart buttons
   * @param {Event} event
   */
  function handleAddToCartClick(event) {
    const button = event.target.closest('.comparison-add-to-cart');
    if (!button || button.tagName !== 'BUTTON' || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) {
      console.error('Product Comparison: No variant ID found');
      return;
    }

    addToCart(variantId, button);
  }

  /**
   * Add a variant to the cart
   * @param {string} variantId
   * @param {HTMLButtonElement} button
   */
  function addToCart(variantId, button) {
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1
        }]
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then(function() {
      button.textContent = 'Added!';

      // Dispatch cart update event for theme components
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { source: 'product-comparison' }
      }));

      // Also try to open cart drawer if it exists
      openCartDrawer();

      // Reset button after delay
      setTimeout(function() {
        button.disabled = false;
        button.textContent = originalText;
      }, 2000);
    })
    .catch(function(error) {
      console.error('Product Comparison: Error adding to cart', error);
      button.textContent = 'Error';

      setTimeout(function() {
        button.disabled = false;
        button.textContent = originalText;
      }, 2000);
    });
  }

  /**
   * Attempt to open the cart drawer
   */
  function openCartDrawer() {
    // Try clicking the cart icon to open drawer
    const cartIcon = document.querySelector('[data-cart-icon], .header-actions__cart-icon, [href="/cart"]');
    if (cartIcon && typeof cartIcon.click === 'function') {
      // Small delay to let cart update first
      setTimeout(function() {
        cartIcon.click();
      }, 100);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
